import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=b61b3eda&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=b61b3eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b3eda",
  null
  
)

export default component.exports